// Shared constants for the two contact-view surfaces (ContactCardPage
// ACT!-style and ContactDetailPage modern). Duplicating these across
// both pages caused a bug earlier where adding SMS support required
// updating two source-of-truth lists — this file is the single source.
//
// If you add a new activity type or call outcome, update ONLY this file.

import {
  Phone, EnvelopeSimple, VideoCamera, NotePencil, ChatCircleDots,
} from '@phosphor-icons/react';

export const ACTIVITY_ICONS = {
  call: Phone,
  email: EnvelopeSimple,
  meeting: VideoCamera,
  note: NotePencil,
  sms: ChatCircleDots,
};

// Text-only colors used by the classic ACT! card page's timeline pills.
export const ACTIVITY_COLORS_TEXT = {
  call: 'text-green-600',
  email: 'text-blue-600',
  meeting: 'text-purple-600',
  note: 'text-amber-600',
  sms: 'text-teal-600',
};

// Full badge styling used by the modern ContactDetailPage timeline.
export const ACTIVITY_COLORS_BADGE = {
  call: 'bg-green-100 text-green-700 border-green-200',
  email: 'bg-blue-100 text-blue-700 border-blue-200',
  meeting: 'bg-purple-100 text-purple-700 border-purple-200',
  note: 'bg-amber-100 text-amber-700 border-amber-200',
  sms: 'bg-teal-100 text-teal-700 border-teal-200',
};

// ACT!-style call outcomes — keep this list identical across the app
// so Boolean Lookup and reports don't miss records.
export const CALL_OUTCOMES = [
  'Connected',
  'Left voicemail',
  'No answer',
  'Callback requested',
  'Meeting scheduled',
  'Not interested',
  'Bad number',
];

export const RELATIONSHIP_TYPES = [
  'colleague', 'manager', 'reports-to', 'referral', 'spouse',
  'parent-company', 'subsidiary', 'vendor', 'client', 'partner', 'other',
];
